import { Component, inject } from "@angular/core";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { ItemLinkableBase } from "@app/shared/linkable/item-linkable-base";
import { Observable } from "rxjs";
import { IHasGuid } from "@app/shared/interfaces/IHasGuid";
import { RendererConfig } from "@models/workspace/RendererConfig";
import { LinkableIconConfig } from "@app/shared/models/Linkable/LinkableIconConfig";
import { AuditFindingDataService } from "../services/audit-finding-data.service";
import { injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/audit-finding/i18n/scope";
import { LinkableComponent } from "@app/shared/linkable/linkable.component";

@Component({
    selector: "findings-linkable",
    templateUrl: "./findings-linkable.component.html",
    imports: [LinkableComponent],
    viewProviders: [provideTranslationScope(scope)],
})
export class FindingsLinkableComponent extends ItemLinkableBase {
    hasAccessChecks = {};
    accessCheckInProgress = false;

    rowIconConfig: LinkableIconConfig[] = [];

    rendererConfig: RendererConfig[] = [];

    private _findingsDS = inject(AuditFindingDataService);
    private _pages = inject(Pages);
    private _tabService = inject(TabService);
    private _translation = injectTranslation(scope);

    hasAccessToItem(guid: string): Observable<boolean> {
        return this._findingsDS.hasAccess(guid);
    }

    async openTab(item: IHasGuid, hasAccess: boolean) {
        if (hasAccess === true) {
            this._tabService.generateTab(
                this._pages.AuditFindingDetail,
                item.guid,
                `(A.F.) ${item[this.displayValueProp]}`
            );
        } else {
            await this._translation.ready();
            this._toastr.warning(
                this._translation.t("findingsLinkable.notEnoughRights")
            );
        }
    }
}
